import typeTab from './typetab.vue'

const tT = {
    install(Vue) {
        Vue.component('zh-typetab', typeTab)
    }
}

export default tT;
